var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('canvas',{staticClass:"video-element mx-auto mb-4 pa-2",attrs:{"id":"video-canvas"},on:{"click":function($event){return _vm.changeState()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }